import React from "react";
import "./../styles/footerStyle.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const [notices, setNotices] = useState([]);
  useEffect(() => {
    fetchNotices();
  }, []);
  const fetchNotices = async () => {
    const data = {
      domain: {
        projectStatus: "",
        projectName: "",
        projectNo: "",
      },
      pageNum: 1,
      pageSize: 5,
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "tenant-id": "0",
      },
      body: JSON.stringify(data),
    };

    try {
      const res = await fetch("/prod-api/procure/page", options);

      // 检查响应状态码是否为 200
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const responseData = await res.json();
      console.log(responseData);

      setNotices(responseData.data.records);
    } catch (error) {
      console.error("Error fetching notices:", error.message);
      // 这里可以根据需要显示用户友好的错误信息
    }
  };
  return (
    <div className="footer">
      <div className="footerName">
        <img className="footerName-logo" src="/assets/logo2.png" alt="logo" />
        <div className="footerNameText">江苏云网数智信息技术有限公司</div>
      </div>
      <div className="footerBody">
        <div className="footerConnect">
          <div className="connectItem">
            <div className="connectItemIcon">
              <img src="/assets/phone.png" alt="phone" />
            </div>
            <div className="connectItemLMessage">
              <span className="connectTitle">销售及服务:</span>
              <span className="connectContent">025-87180891</span>
            </div>
          </div>
          <div className="connectItem">
            <div className="connectItemIcon">
              <img src="/assets/email.png" alt="email" />
            </div>
            <div className="connectItemLMessage">
              <span className="connectTitle">咨询邮箱:</span>
              <span className="connectContent">ywsz@ywsz.net.cn</span>
            </div>
          </div>
        </div>
        <div className="footerMessages">
          <div className="messsageItem">
            <span className="messageTitle">服务能力</span>
            <span className="messageContent">
              <Link
                className="item"
                onClick={scrollToTop}
                to={"/service/digitaltwin"}
              >
                数字孪生
              </Link>
              <Link
                className="item"
                onClick={scrollToTop}
                to={"/service/smartParking"}
              >
                智慧停车
              </Link>
              <Link
                className="item"
                onClick={scrollToTop}
                to={"/service/cloudChain"}
              >
                智盾云链
              </Link>
              <Link
                className="item"
                onClick={scrollToTop}
                to={"/service/addressManagement"}
              >
                地址治理
              </Link>
              <Link
                className="item"
                onClick={scrollToTop}
                to={"/service/GIS-servicePlatform"}
              >
                GIS服务平台
              </Link>
            </span>
          </div>
          <div className="messsageItem">
            <span className="messageTitle">采购公告</span>
            <span className="messageContent">
              {notices.map((item, index) => (
                <Link
                  className="item"
                  onClick={scrollToTop}
                  to={"/Notice"}
                  key={index}
                  title={item.projectName}
                >
                  {item.projectName}
                </Link>
              ))}
            </span>
          </div>
          <div className="messsageItem">
            <span className="messageTitle">关于我们</span>
            <span className="messageContent">
              <Link className="item" onClick={scrollToTop} to={"/Join"}>加入我们</Link>
            </span>
          </div>
        </div>
      </div>
      <div className="footerDrive"></div>
      <div className="footerCopyright">
        <span>2002 ywsz Corporation All Rights Reserved.</span>
        <span className="footerCopyrightLogo">
          <img src="/assets/removebg.png" alt="logo" />
          <span>苏公网安备 32010502010525号</span>
        </span>
        <span>苏ICP备2022033126号</span>
      </div>
    </div>
  );
}
